import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { trackEvent } from 'queries/user/track';

export function CheckBrowserSupport() {
  const { t } = useTranslation(['common']);

  useEffect(() => {
    if (
      typeof String.prototype.replaceAll === 'undefined' ||
      typeof Object.fromEntries === 'undefined'
    ) {
      trackEvent('Browser is too old', { ua: navigator.userAgent });
      alert(t('common:browserTooOld'));
    }
  }, [t]);

  return null;
}
